const welcome = {
    title: '歡迎來到管理控制台',
    description: '管理控制台是一個無需代碼操作的應用。你可以用它來管理登錄體驗。讓我們首先創建一個帳號。你可以用它以個人或公司的身份管理 GptHouse。',
    create_account: '創建帳號',
};
export default Object.freeze(welcome);
